import css from './Divider.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Grid, GridColumn, GridContainer } from 'components/Layout/Grid'

interface Props {
  type: 'usable' | 'upcoming' | 'past'
}

const Divider: React.FC<Props> = (props) => {
  const { type } = props

  const { t } = useTranslation()

  return (
    <GridContainer>
      <Grid className={classNames(css.divider, { [css.usable]: type == 'usable' })}>
        <GridColumn gridColumnStart={{ mobile: 1, laptop: 2 }} gridColumnEnd={{ mobile: 17, laptop: 16 }}>
          <div className={css.wrapper}>
            <div className={css.header}>{t(`wallet:${type}`)}</div>
          </div>
        </GridColumn>
      </Grid>
    </GridContainer>
  )
}

export default Divider
